import React from "react";
import { H6, Label14Medium } from "components/typography";
import { Box } from "@mui/system";


export const NoResultFound = ({ heading = "Sorry, No result found.", body = "Please try another way.", sx }: { heading?: string, body?: string, sx?: any }) => (
  <Box
    data-testid="no-result-found"
    sx={{
      padding: "16px 18px",
      borderRadius: "8px",
      background: "rgba(4, 92, 195, 0.05)",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      ...sx
    }}
  >
    <H6>{heading}</H6>
    <Label14Medium>{body}</Label14Medium>
  </Box>
);

export default NoResultFound;
